import AppHeader from '../AppHeader'
export default {
  name: 'shift-detail',
  components: {
    AppHeader
  },
  created () {
    this.search()
  },
  data () {
    return {
      callbackflg: false
    }
  },
  computed: {
    shiftDetailHayaho () {
      return this.$store.getters.shiftDetailHayaho
    },
    shiftDetailHayaka () {
      return this.$store.getters.shiftDetailHayaka
    },
    shiftDetailNakaho () {
      return this.$store.getters.shiftDetailNakaho
    },
    shiftDetailOsoho () {
      return this.$store.getters.shiftDetailOsoho
    },
    shiftDetailOsoka () {
      return this.$store.getters.shiftDetailOsoka
    },
    shiftDetailSonota () {
      return this.$store.getters.shiftDetailSonota
    },
    shiftDetailShopConfiguration () {
      return this.$store.getters.shiftDetailShopConfiguration
    },
    shiftDetailHoliday () {
      return this.$store.getters.shiftDetailHoliday
    },
    shiftDetailWeek () {
      return this.$store.getters.shiftDetailWeek
    },
    shiftDetailMine () {
      return this.$store.getters.shiftDetailMine
    },
    month () {
      return this.$route.params.ymd.split('-')[1]
    },
    day () {
      return this.$route.params.ymd.split('-')[2]
    },
    afterCommit () {
      var year = parseInt(this.$route.params.ymd.split('-')[0])
      var month = parseInt(this.$route.params.ymd.split('-')[1])
      var day = parseInt(this.$route.params.ymd.split('-')[2])
      var targetDate = new Date(year, month-1, day)

      var base = new Date()
      var base_day = base.getDate()

      if (base_day > 25) {
        base = new Date(base.getFullYear(), base.getMonth() + 2, 0)
      } else {
        base = new Date(base.getFullYear(), base.getMonth() + 1 ,0)
      }
      if (targetDate <= base){
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    search: function() {
      var data = {
        'shop_id': window.localStorage.getItem('shop_id'),
        'target_date': this.$route.params.ymd
      }
      var self = this
      var callback
      callback = function() {
        self.callbackflg = true
      }
      this.$store.dispatch('SHIFT_DETAIL', {data: data, callback: callback})
    },
    weekClass: function(week, holiday) {
      if (holiday) {
        return '-holiday'
      } else if (week == '土') {
        return '-saturday'
      } else if (week == '日') {
        return '-sunday'
      } else {
        return ''
      }
    },
    dayClass: function(week, holiday) {
      if (holiday) {
        return '祝日'
      } else {
        return ''
      }
    },
    classView: function(className, isEdit, isDefault) {
      var ret = ''
      if (className == 'a_haya_ho' || className == 'b_haya_ka') {
        ret = ret + ' -haya'
      } else if (className == 'c_naka_ho') {
        ret = ret + ' -naka'
      } else if (className == 'd_oso_ho' || className == 'e_oso_ka') {
        ret = ret + ' -oso'
      } else if (className == 'f_kyuka') {
        ret = ret + ' -kyuka'
      } else if (className == 'g_sonota') {
        ret = ret + ' -sonota'
      }

      if (isEdit == '1') {
        ret = ret + ' -changed'
      } else if (isDefault == '1') {
        ret = ret + ' -default'
      }
      return ret
    },
    shiftName: function(className) {
      if (className == 'a_haya_ho') {
        return '早番・ホール'
      } else if (className == 'b_haya_ka') {
        return '早番・カウンター'
      } else if (className == 'c_naka_ho') {
        return '中番・ホール'
      } else if (className == 'd_oso_ho') {
        return '遅番・ホール'
      } else if (className == 'e_oso_ka') {
        return '遅番・カウンター'
      } else if (className == 'f_kyuka') {
        return '休暇'
      } else if (className == 'g_sonota') {
        return 'その他'
      }
    },
    shiftTime: function(startH, startM, endH, endM) {
      return startH + ':' + ('00' + startM).slice(-2) + '〜' + endH + ':' + ('00' + endM).slice(-2)
    },
    goShiftList: function() {
      var ym = this.$route.params.ymd.substr(0, 7)
      this.$router.push({ path: '/shift_list/' + ym })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shift-detail.js